<div class="card">
  <div class="options">
    <div class="edit-c">
      <ng-container *ngIf="canEdit">
        <mat-icon class="edit" (click)="edit()">edit</mat-icon>
      </ng-container>
      <!-- Botón para devolver/rechazar caso a 'casos sin asignar' para unidades CAE/CAI y roles específicos -->
      <ng-container *ngIf="canReturnCase">
        <mat-icon
          class="return"
          matTooltip="Devolver caso a 'Casos Sin Asignar' / Rechazar caso"
          (click)="confirmReturnCase()"
          >reply</mat-icon
        >
      </ng-container>
      <!-- Botón para remitir caso a otra unidad, solo visible/usable para Gerente de Línea que pertenezca a la unidad CSA -->
      <ng-container *ngIf="canRemitCSA">
        <mat-icon
          class="remitir"
          matTooltip="Enviar caso a otra unidad (solo Gerente de Línea - unidad CSA)"
          (click)="remitirCSA()"
          >send</mat-icon
        >
      </ng-container>
    </div>
    <div>
      <ng-container *ngIf="canDelete">
        <mat-icon (click)="delete()" class="next">delete</mat-icon>
      </ng-container>
      <ng-container *ngIf="case.status == 'toFinalize' && canFinish">
        <mat-icon (click)="remitTo()" class="next">check</mat-icon>
      </ng-container>
    </div>
  </div>
  <div class="divisor"></div>
  <div class="content">
    <p><b>Numero de caso: </b> {{ case.gai }}</p>
    <!-- <p>
      <b>{{ case.caseType.name == "RAS" ? "Especialista" : "Analista" }}: </b>
      {{ assignedTo }}
    </p> -->
    <p *ngIf="caseType != 'RAS'" class="caseType">
      <b>Tipo de caso:</b> {{ caseType }}
    </p>
    <p *ngIf="caseType == 'RAS'" class="caseType">
      <b>Tipología:</b>
      {{
        case.description.length > 30
          ? case.description.slice(0, 30) + "..."
          : case.description
      }}
    </p>
    <p *ngIf="case.numberRas" class="caseType">
      <b>Número RAS:</b> {{ case.numberRas }}
    </p>
    <!-- <p *ngIf="additionalInformationFechaDelReporte">
      <b>Fecha del Reporte:</b>
      {{ additionalInformationFechaDelReporte | date: "dd/MM/yyy" }}
    </p> 
     <p *ngIf="additionalInformationFechaDelReporte">
      <b>Número de Identificación:</b>
      {{ additionalInformationNumeroDeIdentificacion }}
    </p>
    <p *ngIf="additionalInformationFechaDelReporte">
      <b>Nivel de Riesgo:</b> {{ additionalInformationNivelDeRiesgo }}
    </p> -->
    <!-- <div *ngIf="additionalInformationFechaDelReporte">
      <div
        class="square red"
        *ngIf="additionalInformationNivelDeRiesgo == 'Riesgo Alto'"
      ></div>
      <div
        class="square mostaza"
        *ngIf="additionalInformationNivelDeRiesgo == 'Riesgo Medio'"
      ></div>
      <div
        class="square amarillo"
        *ngIf="additionalInformationNivelDeRiesgo == 'Riesgo Bajo'"
      ></div>
    </div>
    </div> -->
    <!-- </p> -->
  </div>
  <ng-container *ngIf="canOpen">
    <mat-icon class="see" (click)="goToCase()">visibility</mat-icon>
  </ng-container>
  <div class="botOptions">
    <div *ngIf="aproved" class="divCheckAproved">
      <mat-icon class="checkAproved">check_circle</mat-icon>
      <p class="checkAproved textAproved">Aprobado</p>
    </div>
    <!-- <div
      (click)="changeUnif()"
      *ngIf="aproved && secondAp && !appUnif && canApprovedUnif"
      class="divCheckAproved"
    >
      <mat-icon class="checkAprove">error</mat-icon>
      <p class="checkAprove textAproved">Aprobar UNIF</p>
    </div> -->
    <div *ngIf="allDataFalse" class="divCheckAproved">
      <mat-icon class="checkAprove">error</mat-icon>
      <p class="checkAprove textAproved">Completar datos</p>
    </div>
    <!-- <div *ngIf="requireSecondAp" class="divCheckAproved">
      <mat-icon class="checkAprove">error</mat-icon>
      <p class="checkAprove textAproved">requiere aprobación ODC</p>
    </div> -->
    <div *ngIf="requireSecondAp" class="divCheckAproved">
      <mat-icon class="checkAprove">error</mat-icon>
      <p class="checkAprove textAproved">requiere aprobación</p>
    </div>
    <div *ngIf="requireLevelThree" class="divCheckAproved">
      <mat-icon class="checkAprove">error</mat-icon>
      <p class="checkAprove textAproved">requiere aprobación</p>
    </div>
    <div *ngIf="requireFirstdAp" class="divCheckAproved">
      <mat-icon class="checkAprove">error</mat-icon>
      <p class="checkAprove textAproved">requiere aprobación Gerente</p>
    </div>
    <div
      *ngIf="!controlRas && canControlRas"
      (click)="canControlRas ? addNumberRas() : alert('Debe ser Gerente')"
      class="divCheckAproved"
    >
      <mat-icon class="checkAprove">error</mat-icon>
      <p class="checkAprove textAproved">requiere Número Control RAS</p>
    </div>
    <div *ngIf="appUnif" class="divCheckAproved">
      <mat-icon class="checkAprovedUnif">check_circle</mat-icon>
      <p class="checkAprovedUnif textAproved">UNIF</p>
    </div>
    <div class="iconTaskDiv">
      <mat-icon>assignment</mat-icon>
      <p class="marginTaskNumber">{{ case.b - case.a }}/{{ case.b }}</p>
    </div>
  </div>
</div>
